import LegalPage from "../../components/LegalPage";

export default function Reglement() {
  return (
    <LegalPage title="Règlement des défis" kicker="Règlement">
      <h2>1. Conditions de participation</h2>
      <p>
        La participation à un défi nécessite un code valide correspondant à
        la catégorie du défi (standard ou Golden Quizz).
      </p>
      <h2>2. Déroulement</h2>
      <p>
        Chaque question dispose d&apos;un temps limité. Le score final est
        calculé sur la base des bonnes réponses et de la rapidité.
      </p>
      <h2>3. Classement</h2>
      <p>
        Le classement final est dédupliqué par joueur : seul le meilleur
        score d&apos;un même joueur est retenu dans le classement public, et
        seul ce meilleur score donne droit à la cagnotte si le joueur est
        gagnant.
      </p>
      <h2>4. Gains</h2>
      <p>
        Les gains sont versés exclusivement aux joueurs figurant dans les
        premiers rangs du classement final dédupliqué, après vérification.
        Le montant de la cagnotte est défini par l&apos;administrateur.
      </p>
      <h2>5. Réclamation</h2>
      <p>
        Les gagnants doivent renseigner un IBAN au nom du titulaire du
        compte. Le versement est effectué après vérification.
      </p>
      <h2>6. Fraude / abus</h2>
      <p>
        Toute tentative de manipulation conduit à la disqualification et
        peut entraîner la suppression du compte.
      </p>
    </LegalPage>
  );
}
